module.exports = __webpack_public_path__ + "img/camera2.afd724df.svg";